// ControlInputTextFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import TextInputControlView  from 'common-inputs/TextInputControlView.js';


//=============================================================================
//
// Creates a text input control, given a factoryService
// parameter key and a layout position. The factory key defines the
// control appearance through its template. It defines the initial rectangle
// of the control via a width and height from the factory parameter.
//
// Brad Trebilcock, January 15, 2016
//
//=============================================================================
class ControlInputTextFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.styleColorText ='~inputTextColor';
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle  = '~inputFont';
        attributes.borderStyle= '~inputBorder';
        attributes.borderSize= '~inputBorder';
        attributes.cornerRadius= '~inputBorder';
        attributes.borderColor = '~inputBorderColor';
        attributes.styleBGColorText = '~inputBgColor';
        attributes.backgroundColor='~inputBgColor';
		attributes.inlineEditable = true;
        attributes.maxChars = 99;
        attributes.resizePadding = 12;
		attributes.minWidth = 10;
        attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);
        attributes.align = 'left'
        attributes.translateProps = [
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
        ];

        const view = new TextInputControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );

        return view;
    }

}

const controlInputTextFactory = new ControlInputTextFactory();

export default controlInputTextFactory;